module.exports = __webpack_public_path__ + "assets/img/entico1.2659304c.jpg";